
import { BaseVue } from "@newview/base-web";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
@Component({
  components: {},
})
export default class ModalClass extends BaseVue {
  @Prop({ default: false }) show!: Boolean; //弹窗显示/隐藏
  @Prop({ default: true }) isHeader!: Boolean; //
  @Prop({ default: "标题" }) title!: String; //标题内容
  @Prop({ default: 520 }) width!: any; //弹窗宽度
  // @Prop({ default: 100 }) zIndex!: any;        //废弃，改为自动计算层级
  @Prop({ default: true }) closable!: Boolean; //是否有右上角关闭按钮
  @Prop({ default: false }) fullscreen!: Boolean; //全屏（从内容页左上角开始）
  @Prop({ default: false }) fullHeight!: Boolean;   //高度是否铺满
  @Prop({ default: true }) draggable!: Boolean; //是否可以拖动
  @Prop({ default: false }) footerHide!: Boolean; //是否不显示底部，默认显示
  @Prop({ default: true }) mask!: Boolean; //是否显示遮罩，默认显示
  @Prop({ default: "fixed" }) position!: String; //弹窗定位方式 fixed：相对于主体内容定位，absolute：相对于父级元素定位
  @Prop({ default: null }) customTop!: any; //自定义弹窗位置(相对于主体内容)---不传默认垂直居中  类型：number
  @Prop({ default: null }) bgColor!: any; //背景色
  @Prop({ default: null }) color!: any; //字体颜色
  @Prop({ default: false }) isEditMode?: boolean; // 是否为为编辑模式
  @Prop({ default:false}) InBody?:boolean; // 全屏（从浏览器左上角开始）
  @Prop({ default:false}) maxwinable?:boolean; // 是否有窗口最大化功能
  @Prop({ default:false}) ctrlModalSize?:boolean; // 是否可调整窗口大小
  @Prop({ default:""}) customClass?:string; // 是否可调整窗口大小
  
  zIndex = 100;
  modalWidth: any = 520;

  modalBoxId = "ModalBox_" + this.NewGuid();
  modalShow: Boolean = false;
  modalIsShow = false;
  height = "auto";
  maxWidth = "auto";
  maxHeight = "auto";
  top: any = 0;
  left: any = 0;
  @Watch("width")
  widthChange() {
    if (!this.isEditMode) {
      this.modalWidth = this.width;
    }
  }
  @Watch("show")
  showChange(newVal: Boolean) { 
    this.modalShow = this.show;
  }
  @Watch("modalShow")
  showModelChange(newVal: Boolean) { 
    if (this.isEditMode) {
      return;
    }
    if (!newVal) {
      return;
    }
    if (this.position == "fixed") {
      this.$nextTick(() => {
        let body: any = $("body");
        if ($("div[id*='MainPageContent_']").length > 0) {
          body = $("div[id*='MainPageContent_']:visible");
        }
        body.append(this.$el);
      });
    }
    this.zIndex = this.getMaxZIndex()+1;
    // this.zIndex = this.getMaxZIndex()+1;
    this.modalIsShow = false;
    let modalHeadFootHeight = this.footerHide ? 40 : 40 + 45;
    //主页内容边距及宽高
    let parentOffset: any = { left: 0, top: 0 };
    let parentOffset_left = 0;
    let parentOffset_top = 0;
    let parentWidth: any = $("body").width();
    let parentHeight: any = $("body").height();
    if ($(".main-tab").length > 0 && !this.InBody) {
      parentOffset = $(".main-tab").offset();
      parentOffset_left = parentOffset.left + 10; //主页左边距(10px)
      parentOffset_top = parentOffset.top + 42; //加42 主页tab标题的高度(32px)+上边距(10px)
      parentWidth = ($(".main-tab").width() as any) - 20; //减去左右边距(左右各10px)
      parentHeight = ($(".main-tab").height() as any) - 52; //主页tab标题的高度(32px)+上下边距(上下各10px)
    }
    if (typeof this.modalWidth == "number") {
      if (this.modalWidth < 100) {
        this.modalWidth = (this.modalWidth / 100) * parentWidth;
      }
      this.modalWidth = this.modalWidth + "px";
    }
    this.maxWidth = parentWidth + "px";
    this.maxHeight = parentHeight - modalHeadFootHeight + "px";
    // 全屏
    if (this.fullscreen && this.position == "fixed") {
      this.modalWidth = this.maxWidth;
      this.height = this.maxHeight;
      this.top = parentOffset_top + "px";
      this.left = parentOffset_left + "px";
      this.modalIsShow = true;
      return;
    }
    if(this.InBody){
      this.modalWidth = parentWidth;
      this.height = parentHeight;
    }
    if(this.fullHeight){
      this.height=this.maxHeight
    }
    this.$nextTick(() => {
      if (!this.footerHide) {
        $(".ModalcontentBox").css("border-radius", "unset");
      }
      // 相对父级定位，参照物发生改变，重新赋值
      if (this.position == "absolute") {
        parentOffset = $("#" + this.modalBoxId)
          .parent()
          .offset();
        parentOffset_left = parentOffset.left;
        parentOffset_top = parentOffset.top;
        parentWidth = $("#" + this.modalBoxId)
          .parent()
          .innerWidth();
        parentHeight = $("#" + this.modalBoxId)
          .parent()
          .innerHeight();
        this.maxWidth = parentWidth + "px";
        this.maxHeight = parentHeight - modalHeadFootHeight + "px";
        // 铺满父元素
        if (this.fullscreen) {
          this.modalWidth = parentWidth + "px";
          this.height = this.maxHeight;
          this.top = parentOffset_top + "px";
          this.left = parentOffset_left + "px";
          this.modalIsShow = true;
          return;
        }
      }
      // 弹窗居中计算
      let modalW: any = $("#" + this.modalBoxId).width();
      let modalH: any = $("#" + this.modalBoxId).height();
      let topnum = parentOffset_top + (parentHeight - modalH) / 2;
      this.top = topnum + "px";
      if (topnum < parentOffset_top) {
        this.top = parentOffset_top + "px";
      }
      let leftnum = parentOffset_left + (parentWidth - modalW) / 2;
      this.left = leftnum + "px";
      if (leftnum < parentOffset_left) {
        this.left = parentOffset_left + "px";
      }
      if (!this.isNull(this.customTop)) {
        this.top = parentOffset_top + this.customTop + "px";
      }
      if(this.InBody){
        this.top = "0px"
      }
      this.modalIsShow = true;
    });
  }
  // getMaxZIndex() {
  //   var maxZ = Math.max.apply(
  //     null,
  //     $.map($("body *"), (e: any, n) => {
  //       if ($(e).css("position") != "static" && $(e).css("display") != "none" && $(e).parents("div").attr("class")?.indexOf("tdt-container")<0) {
  //         return parseInt($(e).css("z-index")) || -1;
  //       } else {
  //         return 0;
  //       }
  //     })
  //   );
  //   return maxZ;
  // }
  getMaxZIndex() {
    var maxZ = Math.max.apply(
            null,
            $.map($("body *"), (e: any, n) => {
              if ($(e).css("position") != "static" && ($(e).css("display") != "none" && $(e).css("visibility") != "hidden") ) {
                if($(e).hasClass("ivu-layout-sider-trigger") || $(e).hasClass("ivu-menu") || $(e).hasClass('ivu-message') || $(e).hasClass("ivu-spin-fullscreen")){
                  return 0
                }
                if($(e).attr("id")=="luckysheet-input-box"){
                  return 0
                }
                return parseInt($(e).css("z-index")) || -1;
              } else {
                return 0;
              }
            })
    );
    let issupcan = this.bodyHasSupcan()
    return issupcan?(maxZ<1000?maxZ+1000:maxZ):maxZ;
  }

  bodyHasSupcan(){
    let is = false
    $("object").each(function(){
      if($(this).prop("outerHTML").indexOf('type="application/supcan-plugin"')>0){
        is=true
      }
    })
    return is
  }

  created() {
    if (!this.isEditMode) {
      this.modalWidth = this.width;
    }
  }
  mounted() {
    if (this.isEditMode) {
      return;
    }
    if (!this.draggable) {
      return;
    }
    let _this = this;
    //拖动元素
    Vue.directive("drag", (el: any, binding) => {
      el.onmousedown = function (e) {
        var disx = e.pageX - el.parentNode.parentNode.offsetLeft;
        var disy = e.pageY - el.parentNode.parentNode.offsetTop;
        document.onmousemove = function (e) {
          let movediffX=(e.pageX - disx);
          let movediffY=(e.pageY - disy);
          let maxdiffL=window.innerWidth-el.parentNode.parentNode.clientWidth;
          let maxdiffB=window.innerHeight-el.parentNode.parentNode.clientHeight;
          let realX=movediffX;
          let realY=movediffY;
          if (movediffX<0) {
            realX=0
          }
          if (movediffY<0) {
            realY=0
          }
          if(maxdiffL< movediffX){
            realX=maxdiffL
          }
          if(maxdiffB< movediffY){
            realY=maxdiffB
          }
          el.parentNode.parentNode.style.left = realX + "px";
          el.parentNode.parentNode.style.top = realY + "px";
          _this.$emit("WinMoving");
        };
        document.onmouseup = function () {
          document.onmousemove = document.onmouseup = null;
        };
      };
    });
    // 控制拖动改变窗口大小
    this.$nextTick(()=>{
      Vue.directive("resize1",(el:any,binding) => {
        let isResize = false
        el.onmousedown = (e)=> {
          let prevX = e.pageX
          let prevY = e.pageY
          let prevW = Number(el.parentNode.style.width.replace("px",""))
          isResize = true
          let prevH = Number(this.getElementById(el.parentNode.id+"_content").style.height.replace("px",""))
          document.onselectstart=function(){return false}
          document.onmousemove = (e2)=> {
            if(!isResize){
              return
            }
            let movediffX = e2.pageX;
            let movediffY = e2.pageY;
            if(movediffX<0){
              movediffX = 0
            }
            if(movediffY<0){
              movediffY = 0
            }
            if(el._prevClass.indexOf("resize-btn-1")>=0){
              el.parentNode.style.left = movediffX + "px";
              el.parentNode.style.width = (prevW + (prevX - movediffX)) + "px";
              el.parentNode.style.maxWidth = (prevW + (prevX - movediffX)) + "px";
            }
            el.parentNode.style.top = movediffY + "px";
            this.getElementById(el.parentNode.id+"_content").style.height = (prevH + (prevY - movediffY)) + "px";
            this.getElementById(el.parentNode.id+"_content").style.maxHeight = (prevH + (prevY - movediffY)) + "px";
          }
          document.onmouseup = function () {
            isResize = false
            document.onmousemove = document.onmouseup = null;
            document.onselectstart=function(){return true}
          }
        }
      })
      Vue.directive("resize2",(el:any,binding) => {
        let isResize = false
        el.onmousedown = (e)=> {
          let prevX = e.pageX
          let prevY = e.pageY
          let prevW = Number(el.parentNode.style.width.replace("px",""))
          isResize = true
          let prevH = Number(this.getElementById(el.parentNode.id+"_content").style.height.replace("px",""))
          document.onselectstart=function(){return false}
          document.onmousemove = (e2)=> {
            if(!isResize){
              return
            }
            let movediffX = e2.pageX;
            let movediffY = e2.pageY;
            if(movediffX<0){
              movediffX = 0
            }
            if(movediffY<0){
              movediffY = 0
            }
            
            if(el._prevClass.indexOf("resize-btn-2")>=0){
              el.parentNode.style.top = movediffY + "px";
              this.getElementById(el.parentNode.id+"_content").style.height = (prevH + (prevY - movediffY)) + "px";
              this.getElementById(el.parentNode.id+"_content").style.maxHeight = (prevH + (prevY - movediffY)) + "px";
            }
            el.parentNode.style.width = (prevW - (prevX - movediffX)) + "px";
            el.parentNode.style.maxWidth = (prevW - (prevX - movediffX)) + "px";
          }
          document.onmouseup = function () {
            isResize = false
            document.onmousemove = document.onmouseup = null;
            document.onselectstart=function(){return true}
          }
        }
      })
      Vue.directive("resize3",(el:any,binding) => {
        let isResize = false
        el.onmousedown = (e)=> {
          let prevX = e.pageX
          let prevY = e.pageY
          let prevW = Number(el.parentNode.style.width.replace("px",""))
          isResize = true
          let prevH = Number(this.getElementById(el.parentNode.id+"_content").style.height.replace("px",""))
          document.onselectstart=function(){return false}
          document.onmousemove = (e2)=> {
            if(!isResize){
              return
            }
            let movediffX = e2.pageX;
            let movediffY = e2.pageY;
            if(movediffX<0){
              movediffX = 0
            }
            if(movediffY<0){
              movediffY = 0
            }            
            if(el._prevClass.indexOf("resize-btn-3")>=0){
              el.parentNode.style.width = (prevW - (prevX - movediffX)) + "px";
              el.parentNode.style.maxWidth = (prevW - (prevX - movediffX)) + "px";
            }
            this.getElementById(el.parentNode.id+"_content").style.height = (prevH - (prevY - movediffY)) + "px";
            this.getElementById(el.parentNode.id+"_content").style.maxHeight = (prevH - (prevY - movediffY)) + "px";
          }
          document.onmouseup = function () {
            isResize = false
            document.onmousemove = document.onmouseup = null;
            document.onselectstart=function(){return true}
          }
        }
      })
      Vue.directive("resize4",(el:any,binding) => {
        let isResize = false
        el.onmousedown = (e)=> {
          let prevX = e.pageX
          let prevY = e.pageY
          let prevW = Number(el.parentNode.style.width.replace("px",""))
          isResize = true
          let prevH = Number(this.getElementById(el.parentNode.id+"_content").style.height.replace("px",""))
          document.onselectstart=function(){return false}
          document.onmousemove = (e2)=> {
            if(!isResize){
              return
            }
            let movediffX = e2.pageX;
            let movediffY = e2.pageY;
            if(movediffX<0){
              movediffX = 0
            }
            if(movediffY<0){
              movediffY = 0
            }
            if(movediffY>window.innerHeight - 10){
              movediffY = window.innerHeight - 10
            }           
            if(el._prevClass.indexOf("resize-btn-4")>=0){
              this.getElementById(el.parentNode.id+"_content").style.height = (prevH - (prevY - movediffY)) + "px";
              this.getElementById(el.parentNode.id+"_content").style.maxHeight = (prevH - (prevY - movediffY)) + "px";
            }
            el.parentNode.style.left = movediffX + "px";
            el.parentNode.style.width = (prevW + (prevX - movediffX)) + "px";
            el.parentNode.style.maxWidth = (prevW + (prevX - movediffX)) + "px";
          }
          document.onmouseup = function () {
            isResize = false
            document.onmousemove = document.onmouseup = null;
            document.onselectstart=function(){return true}
          }
        }
      })
      
      // ctrl+滚轮缩放浏览器时弹窗界面重新渲染大小
      document.addEventListener('wheel', (event)=> {
        if (event.ctrlKey && event.deltaY !== 0) { // Ctrl + 上/下滚动
          setTimeout(() => {
            if(this.modalShow){
              this.showModelChange(true)
            }
          }, 200);
        }
      });      
      // 增加window监听
      window.addEventListener('resize', () => {
        setTimeout(() => {
          if(this.modalShow){
            this.showModelChange(true)
          }
        }, 200);
      })
    })
    
  }
  closeModal() {
    this.modalShow = false;
    this.$emit("update:show", false);
    this.$emit("close");
  }
  
  modalIsFull = false;
  fullScreenEvent(){
    this.modalIsFull = !this.modalIsFull
    if(this.modalIsFull){
      let modalHeadFootHeight = this.footerHide ? 40 : 40 + 45;
      let parentWidth: any = $("body").width();
      let parentHeight: any = $("body").height();
      this.top = "0px"
      this.left = "0px"
      this.maxWidth = parentWidth + "px";
      this.modalWidth = parentWidth+ "px";
      this.height = (parentHeight - modalHeadFootHeight)+ "px";
      this.maxHeight = (parentHeight - modalHeadFootHeight)+ "px";      
    }else{
      this.showModelChange(true)
    }
  }
}
